/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of a transaction within the card payment lifecycle.
 */
export const CardTransactionStatus = {
  Initiated: "initiated",
  Confirmed: "confirmed",
  Canceled: "canceled",
  Settled: "settled",
  Failed: "failed",
  Completed: "completed",
} as const;
/**
 * Status of a transaction within the card payment lifecycle.
 */
export type CardTransactionStatus = ClosedEnum<typeof CardTransactionStatus>;

/** @internal */
export const CardTransactionStatus$inboundSchema: z.ZodNativeEnum<
  typeof CardTransactionStatus
> = z.nativeEnum(CardTransactionStatus);
/** @internal */
export const CardTransactionStatus$outboundSchema: z.ZodNativeEnum<
  typeof CardTransactionStatus
> = CardTransactionStatus$inboundSchema;
